import getValidationErrors from '~/util/getValidationErrors';
import getValidationFns from '../getValidationsFns';
import { keys } from 'ramda';
import type { ErrorObj, ZapierFieldsFE } from '../../types';

/**
 * Get the errors for the fields.
 * @param {ZapierFieldsFE} updatedFields - The updated fields.
 * @param {Array<string>} duplicateKeys - The duplicate keys.
 * @returns {Object<id: string, ErrorObj>} - The errors.
 * keywords: getErrors, zapier, fields, errors
 */
const getErrors = ({
  updatedFields,
  duplicateKeys,
}: {
  updatedFields: ZapierFieldsFE;
  duplicateKeys: Array<string>;
}): { [id: string]: ErrorObj } =>
  updatedFields.reduce(
    (acc, field) => {
      if (!field.id) return acc;

      const errorObj: ErrorObj = {
        key: [],
        label: [],
        defaultString: [],
        defaultNumber: [],
        defaultBoolean: [],
      };

      keys(field).forEach(key => {
        if (key === 'id') return;
        errorObj[key] = getValidationErrors(
          getValidationFns({
            fieldName: key,
            duplicateKeys,
          }),
          field[key],
        );
      });

      acc[field.id] = errorObj;

      return acc;
    },
    {} as { [id: string]: ErrorObj },
  );

export default getErrors;
